import Layout from '../components/Layout';
import API from '../api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import {getServerSidePaths} from "@/pages/contacts/[slug]";
import RequestPrice from "@/components/RequestPrice";

// Заглушка для переводов
const translate = s => s;

const RequestPricePage = ({ data }) => {
    return <RequestPrice data={data} />;
};

const breadcrumbs = [
    { title: translate('Главная'), route: '/' },
    { title: translate('Запросить прайс'), route: '/requestprice' },
];

RequestPricePage.getLayout = (page, t) => (
    <Layout page={page.props} breadcrumbs={breadcrumbs} title={t('Обратная связь — UNIFROST')}>
        {page}
    </Layout>
);

export async function getServerSideProps(context) {
    const props = { data: {} };

    try {
        const res = await API.get(`/v1/api/pages/requestprice/`, {
            headers: { 'Accept-Language': context.locale },
        });

        if (res.status === 200) {
            if (res.data) props.data = res.data;
        }
    } catch (error) {}

    return {
        props: {
            ...props,
            ...(await serverSideTranslations(context.locale, ['common', 'menu', 'feedback'])),
        },
        // revalidate: 60,
    };
}

export default RequestPricePage;
